import React, { useState, useEffect } from "react";
import './priceComponent.css';
import UnderConstruction from "./UnderConstruction";

const PaymentComponent = () => {
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedPlans, setSelectedPlans] = useState([]);
  const [plans, setPlans] = useState([]);
  const [countries, setCountries] = useState(null);



  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const res = await fetch(`${global.API_STRIPEAPI_URL}getAllPlansForWebsite`);
        const data = await res.json();
        setPlans(data.plans || []);
        //filter by selected country 
        const allPlans = data.plans || [];
        const allCountries = data.country || [];
        const filteredPlans = allPlans.filter(plan =>
          plan.countryName === allCountries[0]
        );
        
        setSelectedPlans(filteredPlans);
        
        setCountries(allCountries);
        setSelectedCountry(allCountries[0] || "");
      } catch (err) {
        console.error("Error fetching plans:", err);
      }
    };
    fetchPlans();
  }, []);


  const handleCountryChange = (country) => {
    setSelectedCountry(country);
    const filteredPlans = plans.filter(plan => plan.countryName === country);
    
    setSelectedPlans(filteredPlans);
  };


  return (
    <div className="pricing-section">
      {countries && countries.length === 0 ? (
        <div className="loader-container">
          <UnderConstruction />
        </div>
      ) : (
        <div>
          <div className="pricing-header">
            <h2>Plans & Pricing</h2>
            <p>Choose a plan that suits your business</p>
          </div>

          <div className="dropdown-container">
            <select
              className="custom-select"
              value={selectedCountry}
              onChange={(e) => handleCountryChange(e.target.value)}
            >
              {countries &&
                countries.map((country, index) => (
                  <option key={index} value={country}>
                    {country.charAt(0).toUpperCase() + country.slice(1)}
                  </option>
                ))}
            </select>
          </div>

          <div className="pricing-grid">
            {selectedPlans.map((plan, index) => (
              <div
                key={index}
                className={`pricing-card ${index % 2 === 0 ? "even" : "odd"}`}
              >
                <h3 className="plan-title">{plan.productName}</h3>
                <p className="plan-interval">
                  {plan.interval_type.charAt(0).toUpperCase() +
                    plan.interval_type.slice(1)}{" "}
                  | Web + Mobile
                </p>

                <p className="plan-price">
                  {plan.currency.toUpperCase()} {plan.amount}{" "}
                  <span className="old-price">
                    {(plan.amount * 1.06).toFixed(2)}
                  </span>
                </p>
                <p className="setup-fee">
                  {plan.currency.toUpperCase()} {plan.setup_amount}{" "}
                  <span className="setup-text">one-time setup fee</span>
                </p>

                <ul className="feature-list">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="feature-item">
                      <span
                        className={`feature-icon ${
                          feature.is_available ? "available" : "unavailable"
                        }`}
                      >
                        {feature.is_available ? "✔" : "✘"}
                      </span>
                      {feature.name}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentComponent;